/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/shell 层；
 * 2. 负责定义抽壳特征原型对象；
 * 3. 该原型对象是设计树、编辑会话与结果对象共享的抽壳领域入口。
 */

import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import { ShellFeatureDefinitionModel } from '../../definition/shell/ShellFeatureDefinition';
import { FeaturePrototype } from '../FeaturePrototype';

/**
 * 抽壳特征原型。
 */
export class ShellFeaturePrototype extends FeaturePrototype<ShellFeatureDefinitionModel> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        featureId: string;
        definition: ShellFeatureDefinitionModel;
        bindings: FeatureReferenceBinding[];
        sourceSketchId?: string | null;
    }) {
        super(input);
    }
}
